

const ms181 = {
  label: "Locker List",
  pageLabel: "Locker List",
  starting: true,
  url: "ms181",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Branch",
      label: "Parent Branch",
      name: "branch",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "branch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "branch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Locker Number",
        accessor: "LoginName",
        width: 150
      },
      {
        Header: "Vault",
        accessor: "lastname",
        width: 150
      },
      {
        Header: "Locker Type",
        accessor: "email"
      },
      {
        Header: "Locker Key No.",
        accessor: "mobile"
      },
      {
        Header: "Assigned",
        accessor: "pfnumber"
      },
      {
        Header: "Active",
        accessor: "EmployeeID"
      }
    ]
  }
};

export default ms181;
